import { request } from 'src/api/request';

export const getPayerNameSuggestions = async ({ queryParams }) => {
  return await request({
    url: `v1/entities/payer-names/${queryParams}`,
    method: 'GET',
  });
};
